import { Button, InputNumber, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ListPage } from "../../components/ListPage";
import { DocumentStatusTag } from "../../components/DocumentStatusTag";
import { FilterToggle } from "../../components/FilterToggle";
import { hasAnyGrant } from "../../helpers/permissions";
import { useUser } from "../../context/UserContext";
import { fmtMVR, laariToMvr, mvrToLaari } from "../../helpers/format";
import type { PurchaseOrder } from "../../api-models";

const STATUSES = ["DRAFT", "PENDING_APPROVAL", "APPROVED", "PARTIALLY_RECEIVED", "COMPLETED", "REJECTED", "CANCELLED"];

export default function POsListPage() {
  const { user } = useUser();
  const navigate = useNavigate();
  const canWrite = hasAnyGrant(user, "PO.Write");

  return (
    <ListPage<PurchaseOrder>
      title="Purchase Orders"
      endpoint="/pos"
      searchPlaceholder="Search doc no, terms or notes..."
      linkTo={(r) => `/procurement/pos/${r.id}`}
      actions={
        canWrite && (
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate("/procurement/pos/new")}>
            New purchase order
          </Button>
        )
      }
      filters={(controls) => (
        <>
          <Select
            allowClear
            placeholder="Status"
            style={{ width: 190 }}
            options={STATUSES.map((s) => ({ value: s, label: s.replaceAll("_", " ") }))}
            value={controls.value("status")}
            onChange={(v) => controls.set("status", v)}
          />
          <FilterToggle name="open" label="Open only" controls={controls} />
          {/* Held in laari like every stored amount, shown and typed in MVR. The
              high-value-commitment tile arrives with its own threshold already in it. */}
          <InputNumber
            placeholder="Min value (MVR)"
            style={{ width: 170 }}
            min={0}
            value={laariToMvr(controls.num("minValue"))}
            onChange={(v) => controls.set("minValue", v == null ? null : mvrToLaari(Number(v)))}
          />
        </>
      )}
      columns={[
        { title: "Doc No", dataIndex: "docNo", sorter: true },
        { title: "Supplier", render: (_, r) => r.supplier?.name },
        { title: "Total", dataIndex: "totalLaari", sorter: true, render: (v) => fmtMVR(v) },
        { title: "Status", dataIndex: "status", sorter: true, render: (v) => <DocumentStatusTag status={v} /> },
      ]}
    />
  );
}
